import { styled } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState, useRef } from "react";
import Utils from "../../QlikUtils";
import Card from "../../components/Cards/Card";
import NativeFilter from "../../components/NativeFilter/NativeFilter";
import NativeObject from "../../components/NativeObject/NativeObject";
import CustomRadio from "../../components/Radio/CustomRadio";
import { useQlik } from "../../context/Qlik";
import { useSelections } from "../../context/Selections";

import appearance from "../../components/Charts/Appearance";
import BarChartOnDemand from "../../components/Charts/BarChartOnDemand";
import FilterMessage from "../../components/FilterMessage/FilterMessage";
import ChartSkeleton from "../../components/Skeletons/ChartSkeleton";
import TableSkeleton from "../../components/Skeletons/TableSkeleton";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

const LayoutCardWrapper = styled("div")({
  borderRadius: "16px",
  display: "flex",
  width: "100%",
  height: "48%",
  flexGrow: 1,
  paddingRight: "10px",
  ".card": {
    margin: 0,
  },
});

function SelfServiceDesktop({ app, config }) {
  const { cards } = config.selfService;
  const { setSwitchOnDemand } = useQlik();
  const [selectedRadio, setSelectedRadio] = useState("Tabela Pivotada");
  const [hyperCube, setHyperCube] = useState(null);
  const [needFilter, setNeedFilter] = useState(true);

  const [dimensionList, setDimensionList] = useState(null);
  const [measureList, setMeasureList] = useState(null);

  const popupObserverRef = useRef(null);

  useEffect(() => {
    // Mantém a lógica de needFilter se necessário, mas sem contar cliques
    // Se quiser, pode implementar lógica baseada em seleções reais
  }, []);

  useEffect(() => {
    const checkFieldPresence = (fieldList) => {
      let selectionsArr = 0;

      const fieldsToCheck = [
        "Medida",
        "DimensãoTempo",
        "DimensãoProduto",
        "DimensãoDistribuidor",
      ];

      fieldList.forEach((field) => {
        fieldsToCheck.forEach((fieldToCheck) => {
          if (field.qName.includes(fieldToCheck)) {
            selectionsArr++;
          }
        });
      });

      return selectionsArr;
    };

    // app.getList("FieldList", (reply) => {
    //   const fieldList = reply.qFieldList.qItems;

    //   const totalValidSelections = checkFieldPresence(fieldList);
    //   console.log("Total valid selections:", totalValidSelections);

    //   if (totalValidSelections > 1) {
    //     setNeedFilter(false);
    //   } else {
    //     setNeedFilter(true);
    //   }
    // });
  }, [app]);

  useEffect(() => {
    if (selectedRadio === "Gráfico de barras") {
      Utils.createHyperCubeByQlikIdPivotable(
        app,
        cards[0].pivotTable.id,
        "P",
        (res) => {
          // console.log("Pivotable -> ", res);
          Utils.getParams(res.model.layout.qHyperCube, (resParams) => {
            Utils.getCube(
              app,
              resParams.dimensionList,
              resParams.measureList,
              (resCube) => {
                // console.log("Retorno Create Cube ->", resCube);
                setHyperCube(resCube.data.qHyperCube);
              }
            );
          });
        }
      );
    }
  }, [selectedRadio, app, cards]);

  useEffect(() => {
    setSwitchOnDemand(true);
  }, [setSwitchOnDemand]);

  useEffect(() => {
    function ajustarPopover(popover) {
      if (popover && !popover.dataset.ajustado) {
        function applyStyle() {
          popover.style.setProperty('position', 'absolute', 'important');
          popover.style.setProperty('top', '137px', 'important');
          popover.style.setProperty('left', '246px', 'important');
          popover.style.setProperty('margin-right', '0px', 'important');
          popover.style.setProperty('margin-bottom', '10px', 'important');
        }
        // Aplica imediatamente
        applyStyle();
        // Reaplica após 50ms e 100ms para garantir
        setTimeout(applyStyle, 50);
        setTimeout(applyStyle, 100);
        popover.dataset.ajustado = "true";
      }
    }

    function observerCallback(mutationsList) {
      for (const mutation of mutationsList) {
        for (const node of mutation.addedNodes) {
          if (
            node.nodeType === 1 &&
            node.classList.contains('lui-popover-container')
          ) {
            ajustarPopover(node);
          }
        }
      }
    }

    const observer = new MutationObserver(observerCallback);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="app onDemand">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <Card
              header={{
                // titleId: cards[0].title.id,
                tooltip: cards[0].tooltip,
                hardTitle: cards[0].title.hard,
              }}
              expandable
              app={app}
              exportTable
              exportTableId={cards[0].pivotTable.id}
              style={{
                margin: 10,
                flex: 1,
              }}
            >
              <CustomRadio
                onClick={(e) => setSelectedRadio(e)}
                values={cards[0].customRadio}
                initialActive={selectedRadio}
                containerStyle={{ marginBottom: "18px" }}
              />

              <div style={{ height: "100%", display: "flex" }}>
                {selectedRadio === "Tabela Pivotada" ? (
                  <div style={{ height: "auto", width: "220px" }}>
                    <div style={{ height: "52%" }}>
                      <NativeObject
                        app={app}
                        reference={{ id: cards[0].containerFilter.id }}
                        key={cards[0].containerFilter.id}
                        style={{ height: "100%" }}
                      />
                    </div>

                    <div
                      style={{
                        height: "48%",
                        border: "1px solid #e5e5e5",
                        padding: "0px",
                      }}
                    >
                      <NativeFilter
                        app={app}
                        reference={{ id: cards[0].measureFilter.id }}
                        key={cards[0].measureFilter.id}
                        style={{ height: "100%", margin: "0px", padding: 0 }}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <div style={{ width: "99%", height: "100%" }}>
                  {selectedRadio === "Tabela Pivotada" ? (
                    needFilter ? (
                      <div
                        style={{
                          width: "99%",
                          height: "100%",
                          display: "grid",
                          alignItems: "center",
                        }}
                      >
                        <TableSkeleton>
                          <FilterMessage
                            message={
                              "Favor Selecione uma ou mais Dimensões e Medidas para visualizar as informações"
                            }
                            absolute
                          />
                        </TableSkeleton>
                      </div>
                    ) : (
                      <>
                        <NativeObject
                          app={app}
                          key={cards[0].pivotTable.id}
                          reference={{ id: cards[0].pivotTable.id }}
                          type="table"
                        />
                      </>
                    )
                  ) : needFilter ? (
                    <div
                      style={{
                        width: "99%",
                        height: "100%",
                        display: "grid",
                        alignItems: "center",
                      }}
                    >
                      <ChartSkeleton>
                        <FilterMessage
                          message={
                            "Favor Selecione uma ou mais Dimensões e Medidas para visualizar as informações"
                          }
                          absolute
                        />
                      </ChartSkeleton>
                    </div>
                  ) : (
                    <>
                      <BarChartOnDemand
                        app={app}
                        reference={{
                          hypercube: hyperCube,
                          format: "0.00 a",
                          axisFormat: "0.00 a",
                          tooltipFormat: "0.00 a",
                          barWidth: "45%",
                          title: true,
                          zoom: 0,
                        }}
                        options={appearance.barchart("barchartOverview")}
                        autoDataZoom
                      />
                    </>
                  )}
                </div>
              </div>
            </Card>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

SelfServiceDesktop.defaultProps = {
  app: null,
  config: {},
};

SelfServiceDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SelfServiceDesktop;
